const $ = require('jquery');

module.exports = function (settingsService) {
    return {
        restrict: 'E',
        link(scope, element) {
            settingsService.getSettingValue('Search', 'SearchPromptText').then(function (response) {
                scope.searchPromptText = response;
            });

            scope.showSearch = function () {
                if (scope.isSmallFormat) {
                    const searchContainer = element.find('#globalHeaderSearchBar');
                    searchContainer.show();
                    const smallFormatSearchInput = $('#globalHeaderSearchSF');
                    smallFormatSearchInput.focus();

                    // This is a terrible hack used to fix iOS fixed position inputs ackin' a fool
                    // DON'T EVER COPY THIS CODE
                    if (navigator.userAgent.toLowerCase().match('iphone')) {
                        $('html').addClass('fixfixed');
                        $(document).on('mouseup.closesearch', function (e) {
                            if (!searchContainer.is(e.target) && searchContainer.has(e.target).length === 0) {
                                scope.closeSearch();
                            }
                        });
                    }
                }
            };

            scope.closeSearch = function () {
                $(document).off('mouseup.closesearch');
                element.find('#globalHeaderSearchBar').hide();
                $('html').removeClass('fixfixed');
            };
        },
        template: require('./search-bar-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/search/search-bar-directive.js
 **/